export default "__VITE_ASSET__f7f2901a__"